import {
  PaletteColorOptions,
  PaletteOptions,
} from '@material-ui/core/styles/createPalette';
import { Colors } from '..';

const primary = {
  cranBerry: '#DF5181', // light
  ceriseRed: '#D82662', // main
  disco: '#971a44', // dark
};

const secondary = {
  dodgerBlur: '#3394FF', // light
  azureRadiant: '#2F80ED', // main
  endeavour: '#0055B2', // dark
};

const error = {
  carnation: '#F36364', // light
  flamingo: '#F03D3E', // main
  tallPoppy: '#A82A2B', // dark
};

const commonColors: Colors = {
  black: '#000',
  white: '#FFF',
  hitGray: '#ACB5BD',
  manatee: '#858B9A',
  aquaHaze: '#F6F8FA',
  geyser: '#DDE2E5',
  deYork: '#6FCF97',
  concrete: '#F2F2F2',
  tundora: '#282828',
  torchRed: '#F5222D',
  eucalyptus: '#219653',
  alabaster: '#FCFCFC',
  mineShaft: '#333333',
  chablis: '#FFF5F5',
  silver: '#BDBDBD',
  redOrange: '#EB5757',
  goldenrod: '#FAAD14',
  lightGray: '#FAFAFA',
  ...primary,
  ...secondary,
  ...error,
};

const primaryColors: PaletteColorOptions = {
  light: primary.cranBerry,
  main: primary.ceriseRed,
  dark: primary.disco,
  contrastText: commonColors.aquaHaze,
};

const secondaryColors: PaletteColorOptions = {
  light: secondary.dodgerBlur,
  main: secondary.azureRadiant,
  dark: secondary.endeavour,
};

const errorColors: PaletteColorOptions = {
  light: error.carnation,
  main: error.flamingo,
  dark: error.tallPoppy,
  contrastText: commonColors.aquaHaze,
};

const palette: PaletteOptions = {
  common: {
    ...commonColors,
  },
  primary: {
    ...primaryColors,
  },
  secondary: {
    ...secondaryColors,
  },
  error: {
    ...errorColors,
  },
};

export default palette;
